export default "__VITE_ASSET__00ace0e5__"